import React from "react";
import Pricing from "./Pricing";
import Hero from "./Hero";
import NewHero from "./NewHero";
import ProgramOverview from './ProgramOverview'
import Structure from './Structure'
import WhyProgramMatters from './WhyProgramMatters'
import Benefits from './Benefits'
import Enroll from './Enroll'
import Portfolio from './Portfolio'

const Program = () => {
    return (
        <div className="font-jost">
            {/* <Hero/> */}
            <NewHero/>
            <Structure/>
            <Portfolio/>
            {/* <ProgramOverview/> */}
            {/* <WhyProgramMatters/> */}
            {/* <Benefits/> */}
            {/* <Pricing/> */}
            <Enroll/>
        </div>
    )
}

export default Program;